<nb-card class="spreadsheet-card" style="height: 99%">
  <ag-grid-angular
    class="ag-theme-balham ag-grid-kpi"
    [gridOptions]="gridOptions"
    >
  </ag-grid-angular>
</nb-card>
